// Endpoints do módulo Lista de Espera (aawz_waitlist — Blueprint /api/v1/lista-espera).
// Nomes congelados no contrato de junção (spec-001, contracts/juncao-paralela.md) —
// não redeclare em outro lugar.
const BASE = '/api/v1/lista-espera'

export const URL_QUESTIONARIO = `${BASE}/questionario`
export const URL_QUESTIONARIO_RESPOSTA = `${BASE}/questionario/resposta`
export const URL_QUESTIONARIO_REFAZER = `${BASE}/questionario/refazer`
